import axiosInstance from "../../utils/axios";

export const getProjectList = async () => {
    const res = await axiosInstance.get(`/project/get_projects`);
    return res;
};

export async function getActivities() {
    let res = await axiosInstance.get(`/projects/fetch/activities/group`)
    return res
}

export async function getConstructionProgress(id) {
    let responseData = await axiosInstance.post(id ? `/progress/get_progress_activity_wise?activity_type=construction&block_id=${id}` : `/progress/get_progress_activity_wise?activity_type=construction`)
    return responseData
}
export async function getSVGConstructionProgressBlockWise(data){
    let response = await axiosInstance.get(`/progress/get_progress_block_wise?activity_type=construction&activity_id=${data?.activity_id}&part_id=${data?.part_id}`)
    return response
}

export const getPartList = async () => {
    let responseData = await axiosInstance.get(`/part/get_parts`)
    return responseData
}

export const getTrackers = async (args) => {
    if (args) {
        let res = await axiosInstance.get(`/tracker_row/get_count_tracker_type_wise_row_for_block?block=${args}`)
        return res
    } else {
        let res = await axiosInstance.get(`/tracker_row/get_count_tracker_type_wise_row_for_project`)
        return res
    }
}

export const getCount = async (value) => {
    let res = await axiosInstance.post(`/progress/get_deployed_part_for_activity_in_block?activity_id=${value?.id}&part_id=${value?.part_id}`)
    return res
}

export const getbomlist = async (value) => {
    let res = value?.length > 0 ? await axiosInstance.post(`/projects/bom-status/activitymilestone/`, { block_ids: value }) : await axiosInstance.post(`/projects/bom-status/activitymilestone/`, {})
    return res
}


export const getsvgbomlistS = async (value) => {
    let res = await axiosInstance.post(`/projects/bom-status/activitymilestone/`, { tracker_row_ids: value })
    return res
}

export const getBulkBlock = async (id) => {
    let res = await axiosInstance.get(`/tracker_row/bulk/all?block=${id}`)
    return res
}

export const getPierLegends = async () => {
    let res = await axiosInstance.get(`/projects/pierslenged`)
    return res
}


export const getTypeData = async (id, activityId) => {
    let res
    if (activityId) {
        res = await axiosInstance.get(`/progress/get_construction_progress_tracker_row_wise?block_id=${id}&activity_id=${activityId}`)
    }
    else {
        res = await axiosInstance.get(`/progress/get_construction_progress_tracker_row_wise?block_id=${id}`)
    }

    return res
}

export const getBlockData = async () => {
    let res = await axiosInstance.get(`/tracker_row/blocks`, {
        params: {
            is_svg: true
        }
    });
    return res;
}

export const getOverAllSvg = async () => {
    let res = await axiosInstance.post(`/progress/get_progress_activity_wise?activity_type=construction&block_id=all`)
    return res
}

export async function get_all_activities() {
    let activities = await axiosInstance.get(`/projects/fetch/activities/group`)
    return activities
}

export const getMapSize = async (id) => {
    const res = await axiosInstance.get(`/projects/pier-tt/x-y-min-max?block_id=${id}`)
    return res
}

export const updateProgress = async (id, data) => {
    const res = await axiosInstance.patch(`/progress/update_construction_progress/sync?block_id=${id}`, {
        data: data,
    })
    return res
}

export const getTableCoordinates = async (id) => {
    const res = await axiosInstance.get(`/projects/get_all_tracker_coordinates?block_id=${id}`)
    return res
}